module.exports = __webpack_public_path__ + "img/wave.38f9ba21.png";